import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { LOGIN, UNAUTHORIZED } from '../../constants';
import { selectCurrentUser, selectCurrentUserManagerLevel, selectIsDelegate } from './authSlice';

interface RequireAuthProps {
    allowedRoles: string[];
}

const RequireAuth = ({ allowedRoles }: RequireAuthProps) => {
    const user = useSelector(selectCurrentUser);
    const UserManagerLevel: string = useSelector(selectCurrentUserManagerLevel);
    const location = useLocation();
    const isDelegate = useSelector<boolean | undefined | null>(selectIsDelegate);

    return (
        // eslint-disable-next-line no-nested-ternary
        allowedRoles?.includes(UserManagerLevel) || isDelegate ? (
            <Outlet />
        ) : user ? (
            <Navigate to={UNAUTHORIZED} state={{ from: location }} replace />
        ) : (
            <Navigate to={LOGIN} state={{ from: location }} replace />
        )
    );
};
export default RequireAuth;
